import { InjectionToken } from '@angular/core';

export interface AppConfig {
    production: boolean;
    localBackend: boolean;
    localCustomerId?: string;
    apiVersion: string;
    apiUrl: string;
    userName?: string;
    requestId?: string;
    apiKeyDev?: string;
    apiKeyProd?: string;
    authorityServer?: string;
    clientId?: string;
    redirectUri?: string;
    postLogoutRedirectUri?: string;
    silentRedirectUrl?: string;
    apiScope?: string;
    bearerToken?: string;
    survicateWorkspaceKey?: string;
    survicateSurveyId?: string;
}
export const APPCONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
